// Catalogo dei giochi Conjureflow.
// La fonte dei dati è games.json: aggiungi un oggetto lì e il gioco apparirà
// automaticamente in home, sulla sua pagina /giochi/[slug] e nella sitemap
// (rigenerata a ogni build). Nessuna pagina React manuale da creare.
// status: "live" (pulsante Gioca attivo) | "soon" (pagina teaser, CTA disattivata)
import gamesData from "./games.json";

export const games = gamesData;
